export interface LoginData {
  user_email: string;
  user_password: string;
}

export interface RegisterData {
  user_name: string;
  user_last_name: string;
  user_email: string;
  user_password: string;
}

export interface Auth {
  name: string;
  expires: string;
  isAnonymous: boolean;
  isUser: boolean;
  isEditor: boolean;
  isAdmin: boolean;
}

export const defaultAuth: Auth = {
  name: '',
  expires: '',
  isAnonymous: true,
  isUser: false,
  isEditor: false,
  isAdmin: false,
};
